import type { Media } from "@/shared/lib/types"

export const STICKY_TOP_OFFSET =
	"calc(max(var(--tg-viewport-safe-area-inset-top, 0px), var(--tg-viewport-content-safe-area-inset-top, 0px)) + 40px)"

export function getMediaTypeName(type: string): string {
	const baseType = type.replace("_comment", "")
	const typeNames: Record<string, string> = {
		photo: "Фото",
		video: "Видео",
		audio: "Аудио",
		voice: "Голосовое",
		video_note: "Кружочек",
		document: "Файл",
	}
	return typeNames[baseType] || "Файл"
}

export function partitionPostMedia(media: Media[]) {
	const postMedia = (media ?? []).filter((m) => !m.type.endsWith("_comment"))

	return {
		postMedia,
		videoMedia: postMedia.filter((m) => m.type === "video" || m.type === "video_note"),
		photoMedia: postMedia.filter((m) => m.type === "photo"),
		otherMedia: postMedia.filter(
			(m) => m.type !== "video" && m.type !== "video_note" && m.type !== "photo",
		),
	}
}

export function formatMediaDuration(seconds: number): string {
	const total = Math.max(0, Math.floor(seconds))
	const hours = Math.floor(total / 3600)
	const minutes = Math.floor((total % 3600) / 60)
	const secs = String(total % 60).padStart(2, "0")
	if (hours === 0) return `${minutes}:${secs}`
	return `${hours}:${String(minutes).padStart(2, "0")}:${secs}`
}
